import { render, staticRenderFns } from "./ViewCounselor.vue?vue&type=template&id=9ea6693c&scoped=true&"
import script from "./ViewCounselor.vue?vue&type=script&lang=js&"
export * from "./ViewCounselor.vue?vue&type=script&lang=js&"
import style0 from "./ViewCounselor.vue?vue&type=style&index=0&id=9ea6693c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea6693c",
  null
  
)

export default component.exports